import {
  Component,
  OnInit,
  Input,
  forwardRef,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core'
import {NG_VALUE_ACCESSOR, ControlValueAccessor} from '@angular/forms'
import {StorageService} from '../../core/upload/upload.service'

const noop = () => {}

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ImageInputComponent),
  multi: true,
}

export class Upload {
  $key: string
  file: File
  name: string
  url: string
  progress: number
  createdAt: Date = new Date()
  constructor(file: File) {
    this.file = file
  }
}

@Component({
  selector: 'app-image-input',
  templateUrl: './image-input.component.html',
  styleUrls: ['./image-input.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class ImageInputComponent implements OnInit, ControlValueAccessor {
  @Input() src: string
  @Input() uploadpath: string
  @Input() imagename: string
  @Input() default: string
  @Input() contain: boolean
  @ViewChild('inputfile') inputfile: ElementRef

  constructor(public storage: StorageService) {}

  ngOnInit() {}

  private onTouchedCallback: () => void = noop
  private onChangeCallback: (_: any) => void = noop

  //get accessor
  get value(): any {
    return this.src
  }

  //set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.src) {
      this.src = v
      this.onChangeCallback(v)
    }
  }

  delete() {
    this.value = this.default
  }

  select() {
    this.inputfile.nativeElement.click()
  }

  upload(e) {
    if (e && e.target && e.target.files && e.target.files.length >= 0) {
      let file = e.target.files[0]
      this.storage
        .uploadFile(file, this.uploadpath, this.imagename)
        .then(upload => {
          this.value = upload['url']
          e.target.value = ''
        })
    }
  }

  //From ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this.src) {
      this.src = value
    }
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/image-input/image-input.component.ts